module.exports = __webpack_public_path__ + "static/img/icon_bg2_en.5eadad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bg2_en.png
// module id = eJhW
// module chunks = 0